import * as pConst from "../consts/profiles-consts.js";
import * as wConst from "../consts/website-consts.js";

export const InitState = {
  TagsResult: {
    Loaded: false,
    ApiResult: {
      Code: 500, Message: "Empty"
    }
  },
  Tags: {
    Tags: [], Labels: [], Categories: [], Cities: [], Countries: [], Languages: []
  }
};

export const tagsReducer = (state = InitState, action) => {
  switch (action.type) {
    case wConst.ACTION_FETCH_TAGS_PENDING: {
      state = {...state, TagsResult: {...state.TagsResult, Loaded: false}};
      break;
    }
    case wConst.ACTION_FETCH_TAGS_REJECTED: {
      state = {...state, TagsResult: {Loaded: false, ApiResult: action.payload}};
      break;
    }
    case wConst.ACTION_FETCH_TAGS_FULFILLED: {
      state = {...state, TagsResult: {Loaded: true, ApiResult: action.payload}};
      if(action.payload.length) {
        state.Tags.Tags = action.payload.filter((t)=>{return t.Type.Value == "Tag"});
        state.Tags.Labels = action.payload.filter((t)=>{return t.Type.Value == "Label"});
        state.Tags.Categories = action.payload.filter((t)=>{return t.Type.Value == "Category"});
        state.Tags.Cities = action.payload.filter((t)=>{return t.Type.Value == "City"});
        state.Tags.Countries = action.payload.filter((t)=>{return t.Type.Value == "Country"});
        state.Tags.Languages = action.payload.filter((t)=>{return t.Type.Value == "Language"});
      }
      break;
    }
  }
  return state;
};


